import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';

const { Option } = Select;

const AddBug = ({ visible, onClose, onAdd }) => {
  const [form] = Form.useForm();

  const handleFinish = (values) => {
    onAdd(values); // Chama a função para adicionar o bug
    form.resetFields(); // Limpa os campos do formulário
    onClose(); // Fecha o modal
  };

  const handleCancel = () => {
    form.resetFields(); // Limpa os campos do formulário
    onClose(); // Fecha o modal
  };

  return (
    <Modal
      title="Adicionar Bug"
      visible={visible}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Form.Item
          name="descricao"
          label="Descrição"
          rules={[{ required: true, message: 'Informe a descrição' }]}
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          name="tipo"
          label="Tipo"
          rules={[{ required: true, message: 'Selecione o tipo' }]}
        >
          <Select>
            <Option value="Erro">Erro</Option>
            <Option value="Melhoria">Melhoria</Option>
            <Option value="Nova Funcionalidade">Nova Funcionalidade</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <div style={{ textAlign: 'right' }}>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit">
              Salvar
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddBug;
